module.exports = __webpack_public_path__ + "images/for_companies_lp/logo_recycle_tuushin_fb77c4681bbf800193ae160d8e8115a4.jpg";